import {
  afterNextRender,
  Component,
  computed,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { injectResize } from 'ngxtension/resize';
import {
  ControlValueAccessorAdpater,
  controlValueAccessorProvider,
} from '../common/value-accessor';
import { FormsModule } from '@angular/forms';
import { ActionSheetService } from '../action-sheet/action-sheet.service';
import { ActionSheetOption } from '../action-sheet/action-sheet.type';
import { Icon } from '../icon/icon.component';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css'],
  imports: [CommonModule, FormsModule, Icon],
  providers: [controlValueAccessorProvider(Select)],
})
export class Select extends ControlValueAccessorAdpater {
  readonly actionSheet = inject(ActionSheetService);

  title = input<string>('선택');
  options = input<Record<string, any>[]>([]);
  bindValue = input<string>('value');
  bindLabel = input<string>('label');

  actionSheetOptions = computed<ActionSheetOption[]>(() => {
    return (this.options() || []).map(option => ({
      label: option[this.bindLabel()],
      value: option[this.bindValue()],
      handler: () => {
        this.value.set(option[this.bindValue()]);
      },
    }));
  });

  current = computed(
    () =>
      this.options()?.find(
        option => option[this.bindValue()] === this.value()
      ) || {}
  );
  currentLabel = computed(() => this.current()?.[this.bindLabel()] || '');

  resize$ = injectResize();
  isMobile = signal(false);

  constructor() {
    super();

    effect(() => {
      const newValue = this.value();
      if (this.onChange) {
        this.onChange(newValue);
      }
    });

    afterNextRender(() => {
      this.isMobile.set(window.innerWidth < 768);
      this.resize$.subscribe(() => {
        this.isMobile.set(window.innerWidth < 768);
      });
    });
  }

  handleActionSheet() {
    if (!this.isMobile()) return;

    this.actionSheet.create({
      options: this.actionSheetOptions(),
      title: this.title(),
      currentValue: this.value(),
    });
  }

  handleSelect(option: any) {
    this.value.set(option[this.bindValue()]);
    // 드롭다운을 닫기 위해 activeElement 포커스 해제 (DaisyUI dropdown focus 기반)
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }
}
